module.exports = __webpack_public_path__ + "static/media/lodjdjd.b229f226.png";